(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    /**
     * @param {HTMLElement} container
     * @param {string} message
     */
    function showError(container, message) {
      container.innerHTML =
        '<div class="rounded-lg border border-red-200 bg-red-50 p-4"><p class="text-sm text-red-900">' +
        message +
        '</p></div>';
    }

    /**
     * @param {Record<string, string>[]} tableData
     * @returns {HTMLTableElement}
     */
    function createTable(tableData) {
      const table = document.createElement('table');
      table.className = 'w-full border-collapse text-xs';

      const thead = document.createElement('thead');
      thead.className = 'bg-gray-50';
      const headerRow = document.createElement('tr');
      const headers = Object.keys(tableData[0]);
      for (const header of headers) {
        const th = document.createElement('th');
        th.className = 'border-b border-gray-200 px-3 py-2 text-start text-[10px] font-semibold uppercase tracking-[0.08em] text-gray-500';
        th.textContent = header.replace(/_/g, ' ');
        headerRow.appendChild(th);
      }
      thead.appendChild(headerRow);
      table.appendChild(thead);

      const tbody = document.createElement('tbody');
      tbody.className = 'divide-y divide-gray-200';
      let rowIndex = 0;
      for (const row of tableData) {
        const tr = document.createElement('tr');
        tr.className = rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50';
        let colIndex = 0;
        for (const header of headers) {
          const td = document.createElement('td');
          td.className = 'px-3 py-2.5 text-gray-900' + (colIndex === 0 ? ' font-medium' : '');
          td.textContent = row[header] != null ? String(row[header]) : '';
          tr.appendChild(td);
          colIndex += 1;
        }
        tbody.appendChild(tr);
        rowIndex += 1;
      }
      table.appendChild(tbody);
      return table;
    }

    /** @param {HTMLElement} container */
    function renderTable(container) {
      if (container.getAttribute('data-sg-rendered') === 'true') return;
      const jsonData = container.getAttribute('data-json');
      if (!jsonData) {
        showError(container, container.dataset.errorNoData || '');
        return;
      }
      try {
        const data = JSON.parse(jsonData);
        if (!data.table || !Array.isArray(data.table) || data.table.length === 0) {
          showError(container, container.dataset.errorInvalid || '');
          return;
        }
        const table = createTable(data.table);
        container.textContent = '';
        container.appendChild(table);
        container.setAttribute('data-sg-rendered', 'true');
      } catch {
        showError(container, container.dataset.errorLoad || '');
      }
    }

    function initAll() {
      for (const el of document.querySelectorAll('.size-guide-table[data-json]')) {
        renderTable(/** @type {HTMLElement} */ (el));
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
